import { useState, useCallback } from "react";

export const useStatusFilter = () => {
  const [statusValue, setStatusValue] = useState(null);

  const statuses = [
    {
      label: "Active",
      value: "active",
    },
    {
      label: "Inactive",
      value: "inactive",
    },
  ];

  const handleStatusChange = useCallback((selectedValue) => {
    setStatusValue(selectedValue);
  }, []);

  return {
    statuses,
    statusValue,
    handleStatusChange,
    setStatusValue,
  };
};
